<brightside-web-account-statements
  *ngIf="(currentAccountInfo$|async) as account"
  [accountId]="account.accountId">
</brightside-web-account-statements>
